import { render, staticRenderFns } from "./PushNotificationsListing.vue?vue&type=template&id=3230b09c"
import script from "./PushNotificationsListing.vue?vue&type=script&lang=js"
export * from "./PushNotificationsListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports